import React from "react";
import { Box } from "@mui/material";
import { MyNewsSettingsCard } from "my-news/components";
import { myNewsAdminSettingsPageMenuDef } from "my-news/configs/menu-defs";
import { OcPageSideMenu, OcPageTransition } from "oc/components";
import { useOcIsMobile, useOcPageSideMenu } from "oc/hooks";

export const MyNewsAdminSettingsPage = () => {
  const stateId = "myNewsSettingsPageMenuActiveItem";
  const { state: selectedItem } = useOcPageSideMenu({
    id: stateId,
    initialValue: myNewsAdminSettingsPageMenuDef[0].id,
  });

  const isMobile = useOcIsMobile();

  return (
    <OcPageTransition>
      <Box>
        <Box
          id="my-hr-news-settings"
          height="80px"
          style={{ backgroundColor: "#cc0033" }}
          display="flex"
          flexDirection="row"
          alignItems="center"
          paddingLeft="14px"
        >
          <Box style={{ color: "white", fontSize: "24px" }}>MyNews</Box>
        </Box>
        <Box display="flex" flexDirection={isMobile ? "column" : "row"}>
          <OcPageSideMenu
            stateId={stateId}
            menuDef={myNewsAdminSettingsPageMenuDef}
          />
          <Box
            id="my-time-admin-settings"
            flexGrow={1}
            padding={isMobile ? "16px 0px" : "16px"}
          >
            {selectedItem === "myNewsGeneralSettings" && (
              <Box>
                <MyNewsSettingsCard isMobile={isMobile} />
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </OcPageTransition>
  );
};

export default MyNewsAdminSettingsPage;
